import Vue from 'vue'
import moment from 'moment'
import { i18n } from '@/i18n'
import { updateAuthHeader } from '../api/helper'
import errorHandler from './errorHandler'

export default {
  appendToHtmlAttribute (message, error) {
    return `<div data-more-details="${JSON.stringify(error)}">${message}</div>`
  },
  clearLoginData (current) {
    if (!current) {
      throw new Error('Please provide a global class.')
    }

    current.$store.commit('SET_TOKEN', null)
    updateAuthHeader(Vue, null)

    current.$store.commit('SET_USER', '')
    if (current.$cookie) {
      current.$cookie.delete('sid')
    } else if (current.$router.app.$cookie) {
      current.$router.app.$cookie.delete('sid')
    }

    window.localStorage.removeItem('uid')
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('token')
  },
  isMobile () {
    return /(Android|iPhone|iPad)/.test(navigator.userAgent)
  },
  notShowAlertList: [403, 405],
  parseStartTime (retention = '') {
    if (retention === 'infinity') {
      return new Date(0).toJSON()
    }

    let [, number, unit] = retention.trim().match(/(\d*)(\w*)/)

    if (unit === 'm') {
      unit = 'M'
    }

    const formatRetention = ['d', 'w', 'M', 'y'].indexOf(unit) > -1
      ? { [unit]: number }
      : { d: 31 }

    return moment()
      .subtract(formatRetention)
      .toJSON()
  },
  showErrorMessage (current, component, error, message = null) {
    if (!current) {
      throw new Error('Please provide a global class.')
    }

    if (this.notShowAlertList.includes(error.status) && component !== 'general') return
    if (!message) {
      message = current.$t
        ? current.$t(errorHandler(component, error.status, message))
        : i18n.t(errorHandler(component, error.status, message))
    }

    message = this.appendToHtmlAttribute(message, error)

    const data = {
      dangerouslyUseHTMLString: true,
      duration: 0,
      message,
      showClose: true,
      type: 'error'
    }

    current.$message ? current.$message(data) : current.Message(data)
  }
}



// WEBPACK FOOTER //
// ./src/utils/helper.js